import { TypeCloudinaryImageJSON } from 'hello_baby/types/guides'

export const cloudinaryImageURL = (
  cloudinaryJSON?: TypeCloudinaryImageJSON | TypeCloudinaryImageJSON[]
) => {
  if (!cloudinaryJSON) return undefined
  if (Array.isArray(cloudinaryJSON)) {
    if (cloudinaryJSON.length > 0) {
      if ('secureUrl' in cloudinaryJSON[0]) {
        return cloudinaryJSON[0].secureUrl
      }
    }
    return undefined
  }
  if ('secureUrl' in cloudinaryJSON) return cloudinaryJSON.secureUrl
  return undefined
}
